import { createSelector, createFeatureSelector } from '@ngrx/store';
import { CopModuleState, copModuleKey } from '../cop/cop.reducer';
import * as fromIA from './impacted-assets.reducer';

const selectCopModuleState = createFeatureSelector<CopModuleState>(copModuleKey);

const selectImpactedAssetsState = createSelector(selectCopModuleState, (state: CopModuleState) => state?.impactedAssets);

export const selectEmailSummariesForDocument = createSelector(selectImpactedAssetsState, fromIA.getEmailSummariesForDocument);

export const selectSelectedDocumentAssetsByDistance = createSelector(selectImpactedAssetsState, fromIA.getSelectedDocumentAssetsByDistance);

export const selectEmailsExist = createSelector(selectImpactedAssetsState, fromIA.getEmailsExist);

export const selectIsEmailWorking = createSelector(selectImpactedAssetsState, fromIA.getIsEmailWorking);

export const selectClosestAssetRequest = createSelector(selectImpactedAssetsState, fromIA.getClosestAssetRequest);

export const selectEmailMeta = createSelector(selectImpactedAssetsState, fromIA.getEmailMeta);

export const selectSelectedDocumentClosestAssetCounts = createSelector(selectImpactedAssetsState, fromIA.getSelectedDocumentClosestCounts);

export const selectIsClosestRSDTakeover = createSelector(selectImpactedAssetsState, fromIA.getIsClosestRSDTakeover);

export const selectCommunicationMeta = createSelector(selectImpactedAssetsState, fromIA.getCommunicationMeta);

export const selectClosestAssetDropdownValue = createSelector(selectImpactedAssetsState, fromIA.getClosestAssetDropdownValue);

export const selectIsClosestAssetCountWorking = createSelector(selectImpactedAssetsState, fromIA.getIsClosestAssetCountWorking);

export const selectIsClosestAssetWorking = createSelector(selectImpactedAssetsState, fromIA.getIsClosestAssetWorking);

export const selectSelectedShapesAndDocumentsOnMap = createSelector(selectImpactedAssetsState, fromIA.getSelectedShapesAndDocumentsOnMap);
